import * as Components from "../../components";
import App from "../../App";

export const CommonModule = { ...Components, App };
